import { render, staticRenderFns } from "./healthLook.vue?vue&type=template&id=6a40635b&scoped=true&"
import script from "./healthLook.vue?vue&type=script&lang=js&"
export * from "./healthLook.vue?vue&type=script&lang=js&"
import style0 from "./healthLook.vue?vue&type=style&index=0&id=6a40635b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a40635b",
  null
  
)

export default component.exports